import SeqView from './SeqView';
export default SeqView;
